import { BrowserModule } from '@angular/platform-browser';
import {APP_BASE_HREF, CommonModule} from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { InlineWebbookerComponent } from './inline-webbooker.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {FormModule} from '../../app/form/form.module';
import {SharedModule} from '../../app/shared/shared.module';
import {Ng2FlatpickrModule} from '../../app/vendor/ng2-flatpickr';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxSmartModalModule} from 'ngx-smart-modal';
import {RouterModule} from '@angular/router';
import {UcFirstPipeModule} from '../../app/pipes/uc-first.pipe';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslateLoader, TranslateModule, TranslateService, TranslateStore} from '@ngx-translate/core';
import {AuthInterceptor} from '../../app/interceptors/auth.interceptor';
import {CoolStorageModule} from '@angular-cool/storage';
import {StateService} from '../../app/services/state.service';
import {VisitorService} from '../../app/services/visitor.service';
import {AnalyticsService} from '../../app/services/analytics.service';
import {FieldErrorService} from '../../app/services/field-error.service';
import {HttpLoaderFactory} from '../../app/app.module';
import {HtmlPipeModule} from "../../app/pipes/html.pipe";
import {GoogleMapsModule} from '@angular/google-maps';

@NgModule({ exports: [
        InlineWebbookerComponent
    ],
    declarations: [InlineWebbookerComponent], imports: [CommonModule,
        BrowserModule,
        FormModule,
        SharedModule,
        GoogleMapsModule,
        Ng2FlatpickrModule,
        AutocompleteLibModule,
        HtmlPipeModule,
        ReactiveFormsModule,
        NgxSmartModalModule.forChild(),
        RouterModule.forRoot([]),
        UcFirstPipeModule,
        FontAwesomeModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        CoolStorageModule.forRoot()], providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        TranslateService,
        TranslateStore,
        { provide: 'Window', useValue: window },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        StateService,
        VisitorService,
        AnalyticsService,
        FieldErrorService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class InlineWebbookerModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap(): void {
    const el = createCustomElement(InlineWebbookerComponent, {
      injector: this.injector,
    });
    customElements.define('inline-webbooker', el);

    const el2 = createCustomElement(InlineWebbookerComponent, {
      injector: this.injector,
    });
    customElements.define('webbooker-widget', el2);
  }
}
